var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"second"},[_c('a',{on:{"click":function($event){_vm.savingInfo()}}},[(!_vm.isSaving)?_c('easyBtn',{attrs:{"btnText":"Save"}}):_vm._e(),(_vm.isSaving)?_c('img',{staticClass:"loading-animation",attrs:{"src":_vm.savingAnimation}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28e950f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/saveBtn.vue
// module id = null
// module chunks = 